jQuery(function ($) {
    var has_sticky_header = ($('.has-sticky-header').length > 0 );
    if(has_sticky_header){
        var site_container = $('.site-container');
        var sticky_header = $('.sticky-header');
        var header_height = sticky_header.outerHeight();
        var $class = 'box-shadow';


        function set_content_height(){
            header_height = sticky_header.outerHeight();
            site_container.css({
                'top': header_height
            });
        }

        $(set_content_height);

        $(window).resize(function(){
            $(set_content_height);
        });

        $(window).scroll(function () {
            if ($(this).scrollTop() !== 0) {
                sticky_header.addClass($class);
            } else if ($(this).scrollTop() === 0){
                sticky_header.removeClass($class);
            }
        });
    }
});